import { render, staticRenderFns } from "./NProjectSearchBarWithFilter.vue?vue&type=template&id=4bb6c6ae&"
import script from "./NProjectSearchBarWithFilter.vue?vue&type=script&lang=js&"
export * from "./NProjectSearchBarWithFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports